export default (function ($) {

    var _instance = {};

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {

            var $sliderOwl = $(".slider--posts-sidebar").find('.owl-carousel');
            $sliderOwl.owlCarousel({
                animateIn: 'fadeIn',
                animateOut: 'fadeOut',
                autoplay: false,
                dots: false,
                items: 1,
                loop: false,
                lazyLoad: true,
                lazyLoadEager: 1,
                mouseDrag: true,
                touchDrag: true,
                nav: false,
            });

        });
    };

    return _instance;

})(jQuery)
